import Router from 'next/router'
import { useEffect, useState } from 'react'
import { determineFailedAuthRedirectPath, retrieveAuthToken } from '../utils/authUtils'
import { proxyGlobalAuth } from '../proxies/proxyGlobalAuth'
import { retrieveSiteDomainEnum } from '../utils/domainUtils'

export function useAuthenticatedPage (): boolean {
  const [shouldDisplay, setShouldDisplay] = useState(false)
  useEffect(() => {
    const authToken = retrieveAuthToken()
    proxyGlobalAuth.siteDomainEnum = retrieveSiteDomainEnum()
    if (authToken) {
      proxyGlobalAuth.authToken = authToken
      setShouldDisplay(true)
    } else {
      void Router.push(determineFailedAuthRedirectPath())
    }
  }, [setShouldDisplay])
  return shouldDisplay
}
